import { useBxpWebStargateClient } from "@/libraries/bxp-web-stargate-client/src/hook/use-bxp-web-stargate-client";
import {
    GetAccountOrgsRequest,
    GetAccountOrgsResponse
} from "@/libraries/bxp-web-stargate-client/src/hook/use-bxp-web-stargate-client.types";

import { AsyncResult, useAsync } from "./use-async";

export type { GetAccountOrgsRequest, GetAccountOrgsResponse };

export function useAccountOrgs({
    cloudSessionTokenCookie,
    skipNames
}: GetAccountOrgsRequest): AsyncResult<GetAccountOrgsResponse> {
    const stargateClient = useBxpWebStargateClient();

    return useAsync(
        () =>
            stargateClient.getAccountOrgs({
                cloudSessionTokenCookie,
                skipNames
            }),
        []
    );
}
